
export const isFeedbackCenterInStandaloneMode = () => window.location.href.search(/feedback.\.rayapp.io/i) !== -1

export default isFeedbackCenterInStandaloneMode;
